import { DeviceColorScheme, DeviceOsType, DeviceType } from '@inditex/coanalytjs';
import { getDeviceProvider, getHostData } from './device-provider';
import { getCurrentCountry } from 'src/utils/BasePathTools';
import createPrivacyConsent from './privacy-consent';
const OS_TYPE_MAP: Record<string, DeviceOsType> = {
	ios: DeviceOsType.IOS,
	android: DeviceOsType.ANDROID,
	windows: DeviceOsType.WINDOWS,
	'mac os': DeviceOsType.MACOS,
	macos: DeviceOsType.MACOS,
	linux: DeviceOsType.LINUX,
	'chromium os': DeviceOsType.CHROMEOS,
	'chrome os': DeviceOsType.CHROMEOS,
};

const DEVICE_TYPE_MAP: Record<string, DeviceType> = {
	mobile: DeviceType.MOBILE,
	tablet: DeviceType.TABLET,
	desktop: DeviceType.DESKTOP,
};

const COLOR_SCHEME_MAP: Record<string, DeviceColorScheme> = {
	light: DeviceColorScheme.LIGHT,
	dark: DeviceColorScheme.DARK,
	'n/a': DeviceColorScheme.NA,
};

const APP_NAME = 'wsc-zararesell';

const createConnectorConfig = () => {
	const deviceProvider = getDeviceProvider();
	const { platform, appVersion } = getHostData();
	const version = process.env.REACT_APP_VERSION ?? appVersion;

	return {
		application: {
			name: APP_NAME,
			version,
			platform,
			buildNumber: parseInt(version.replace(/\./g, '') || '0', 10) || 0,
		},
		geo: () => ({
			country: getCurrentCountry()?.toUpperCase() ?? '',
			region: ''
		}),
		device: () => {
			const deviceData = deviceProvider.getDeviceData();
			return {
				osType: OS_TYPE_MAP[deviceData?.os?.toLowerCase() ?? ''] ?? DeviceOsType.UNKNOWN,
				osVersion: deviceData?.osVersion ?? '',
				model: deviceData?.name ?? '',
				language: deviceData?.language ?? '',
				type: DEVICE_TYPE_MAP[deviceData?.type?.toLowerCase() ?? ''] ?? DeviceType.UNKNOWN,
				displayResolution: typeof window !== 'undefined'
					? `${window.screen.width}x${window.screen.height}`
					: '',
				colorScheme: COLOR_SCHEME_MAP[deviceData?.colorScheme?.toLowerCase() ?? ''] ?? DeviceColorScheme.LIGHT,
			};
		},
		privacyConsent: () => createPrivacyConsent(),
		batchConfig: {
			maxBatchSize: 4,
			maxQueueSize: 1000,
			flushTimeoutMs: 10_000,
		},
		flushIntervalConfig: {
			flushIntervalMs: 60_000,
			disableFlushInterval: true,
		},
	};
};

export default createConnectorConfig;
